import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=6aa7e111&"
import script from "./Master.vue?vue&type=script&lang=js&"
export * from "./Master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa7e111')) {
      api.createRecord('6aa7e111', component.options)
    } else {
      api.reload('6aa7e111', component.options)
    }
    module.hot.accept("./Master.vue?vue&type=template&id=6aa7e111&", function () {
      api.rerender('6aa7e111', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/containers/Master.vue"
export default component.exports